import { useCallback } from 'react';
import { useI18nLabel } from './useI18nLabel';

export interface JobBenefitLike {
  id: string;
  labelJp: string;
}

export function useJobBenefitOptions() {
  const translate = useI18nLabel();

  const makeOptions = useCallback(
    (jobBenefits: JobBenefitLike[]) => {
      return jobBenefits.map((jobBenefit) => ({
        label: translate(jobBenefit),
        value: jobBenefit.id,
      }));
    },
    [translate]
  );

  return {
    makeOptions,
  };
}
